/* eslint-disable prettier/prettier */
export default () =>({
  status: "extracting",
  segipResponse: null,
  listPrivatedLibertyPersons:null,
  countPersonsCenter:null,
  countGenrePersonsCenter:null,
  countPersonsLegalStatus:null,
  countPersonsByDepartment:null,
  dataToEdit:null,
  statusEdit: "not editing",
  chartData:null,
  chartStatus:null,
  chartDataTwoParams:null,
})
